import {Component, OnInit} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-resources-support-article',
    template: `
        <ng-container i18n="@@support.articles.resources">
            <p>You can find some useful files on this page.</p>

            <h2>Lesson plan</h2>
            <p>You may use these lesson sheets to help schedule the typing classes in your school.</p>
            <p>
                <a
                    href="https://tyyp.ams3.cdn.digitaloceanspaces.com/documents/{{ languageCode }}/Tyyp_lesson_plan.pdf"
                    mat-flat-button
                    color="primary"
                >
                    <mat-icon>download</mat-icon>
                    Lesson plan
                </a>
            </p>

            <h2>Add multiple users: Excel template</h2>
            <p>Enter your students' information in this Excel worksheet. You can then copy and paste the data into the
                grid to add more students.</p>
            <p>
                <a
                    routerLink="/support/organizations/students/enroll"
                    mat-stroked-button
                    color="primary"
                    class="supportLink"
                >Enroll students</a>
            </p>
            <p>
                <a
                    href="/assets/excel/importExamples/{{ languageService.getActiveLanguageCode() }}.xls"
                    mat-flat-button
                    color="primary"
                >
                    <mat-icon>download</mat-icon>
                    Download
                </a>
            </p>
        </ng-container>
    `,
    styles: [
        `
            a {
                margin-right: 8px;
                margin-bottom: 8px;
            }
        `
    ]
})
export class ResourcesSupportArticleComponent implements OnInit {
    languageCode: string;

    constructor(
        public languageService: LanguageService
    ) {
    }

    ngOnInit() {
        this.languageCode = this.languageService.getActiveLanguage().code;
    }
}
